import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { action, computed, flow, observable, runInAction, set } from "mobx";
import { isRatable } from "@devowl-wp/real-utils";
import { BaseOptions } from "@devowl-wp/utils";
import { request } from "../utils/request.js";
import { locationRestSettingsVerifyPost } from "../wp-api/settings-verify.post.js";
import { locationRestSettingsPut } from "../wp-api/settings.post.js";
class OptionStore extends BaseOptions {
    get unimplemented() {
        return this.others.implementations.filter((i)=>i.indexOf("DevOwl") === -1);
    }
    get isRatable() {
        return isRatable(this.slug);
    }
    constructor(rootStore){
        super(), this.updateBusy = false, this.update = flow(function*(thumbnailFolder, thumbnailFilename, chunkSize) {
            this.updateBusy = true;
            try {
                const requestData = {
                    thumbnailFolder,
                    thumbnailFilename,
                    chunkSize
                };
                yield request({
                    location: locationRestSettingsPut,
                    request: requestData
                });
                set(this.others, requestData);
            } catch (e) {
                console.log(e);
                throw e;
            } finally{
                this.updateBusy = false;
            }
        }), this.verify = flow(function*(thumbnailFolder, thumbnailFilename) {
            this.updateBusy = true;
            try {
                const requestData = {
                    thumbnailFolder,
                    thumbnailFilename
                };
                const result = yield request({
                    location: locationRestSettingsVerifyPost,
                    request: requestData
                });
                return result;
            } catch (e) {
                console.log(e);
                throw e;
            } finally{
                this.updateBusy = false;
            }
        });
        this.rootStore = rootStore;
        this.pureSlug = BaseOptions.getPureSlug(process.env.slug);
        this.pureSlugCamelCased = BaseOptions.getPureSlug(process.env.slug, true);
        // Use the localized WP object to fill this object values.
        runInAction(()=>Object.assign(this, window[this.pureSlugCamelCased]));
    }
    setShowLicenseFormImmediate(state) {
        this.others.showLicenseFormImmediate = state;
    }
}
_ts_decorate([
    observable
], OptionStore.prototype, "updateBusy", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], OptionStore.prototype, "others", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], OptionStore.prototype, "unimplemented", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Boolean
    ]),
    _ts_metadata("design:returntype", void 0)
], OptionStore.prototype, "setShowLicenseFormImmediate", null);
export { OptionStore };
